import ACTION_NAMES from "actions/ACTION_NAMES";
import { generateCreateActionCreator, generateReadActionCreator, generateReadOneActionCreator } from "actions/crudActionCreators";
import routes from "actions/routes";

function resetProduct(type) {
    return {
        type,
    }
}

export default {
    getAccountTerm: generateReadOneActionCreator(routes.API_SUBSCRIPTION, ACTION_NAMES.ACCOUNT_TERM),
    getAllProducts: generateReadOneActionCreator(routes.API_SUBSCRIPTION, ACTION_NAMES.SUBSCRIPTION, 'products'),
    modifySubscription: generateCreateActionCreator(routes.API_SUBSCRIPTION, ACTION_NAMES.SUBSCRIPTION, () => {}, () => {}, 'products'),
    getNextInvoice: generateReadOneActionCreator(routes.API_SUBSCRIPTION, ACTION_NAMES.NEXT_INVOICE, 'next_invoice'),
    getProducts: generateReadOneActionCreator(routes.API_SUBSCRIPTION, ACTION_NAMES.CURRENT_SUBSCRIPTION, 'current_products'),
    getTcrDetails: generateReadActionCreator(routes.API_TCR_INFO, ACTION_NAMES.TCR_DETAILS),
    getOutstandingInvoices: generateReadOneActionCreator(routes.API_SUBSCRIPTION, ACTION_NAMES.OUTSTANDING_INVOICES, 'outstanding_invoices'),
    getPlan: generateReadOneActionCreator(routes.API_SUBSCRIPTION, ACTION_NAMES.PLAN, 'plan'),
    checkIfAccountHasOpenSeats: generateReadOneActionCreator(routes.API_SUBSCRIPTION, ACTION_NAMES.SEATS, 'assignment'),
    getTransactionHistory: generateReadOneActionCreator(routes.API_SUBSCRIPTION, ACTION_NAMES.TRANSACTION_HISTORY,"transaction_history"),
    getProductFeatures: generateReadOneActionCreator(routes.API_PRODUCT_FEATURES, ACTION_NAMES.PRODUCT_FEATURES),
    resetProduct
}
